import { setPageTitle } from '../../../utils/utilities'
import ExportPrivateChat from './ExportPrivateChat'
import ExportPublicChat from './ExportPublicChat'
import PrivateMessagesPerDay from './PrivateMessagesPerDay'
import PublicMessagesPerDay from './PublicMessagesPerDay'
import FreeRegistrationCounts from './FreeRegistrationCounts'
import UniqueUsersPerDay from './UniqueUsersPerDay'
import UniqueUsersPerDayExport from './UniqueUsersPerDayExport'
import UserCounts from './UserCounts'
import ViewsPerDay from './ViewsPerDay'
import ViewsPerHour from './ViewsPerHour'

const Stats = () => {
  setPageTitle('Stats')
  return (
    <div className="flex flex-col w-full gap-4 pb-4 md:grid md:grid-cols-2">
      <PublicMessagesPerDay />
      <PrivateMessagesPerDay />
      <ViewsPerHour />
      <ViewsPerDay />
      <UniqueUsersPerDay />
      <UserCounts />
      <FreeRegistrationCounts />
      <UniqueUsersPerDayExport />
      <ExportPublicChat />
      <ExportPrivateChat />
    </div>
  )
}

export default Stats
